<ul class="insurance-images" *ngIf="insuranceData">
    <li class="insurance-images__image" *ngFor="let verzekering of insuranceData">
        <a [routerLink]="'/' + verzekering.url" class="insurance-images__link" *ngIf="verzekering.routerLink">
            <svg class="svg-icon svg-icon--xl">
                <use [attr.href]="'assets/icons-general.svg#' + verzekering.svgLink"></use>
            </svg>
            <p>{{ verzekering.title }}</p>
        </a>
        <a href="{{ baseUrl }}/{{ verzekering.url }}" class="insurance-images__link" *ngIf="!verzekering.routerLink">
            <svg class="svg-icon svg-icon--xl">
                <use [attr.href]="'assets/icons-general.svg#' + verzekering.svgLink"></use>
            </svg>
            <p>{{ verzekering.title }}</p>
        </a>
    </li>
</ul>
